<template>
  <div class="agreement">
    <div class="tabBar">
      <img :src="logoSrc"
           class="logo"
           alt="">
    </div>
    <div class="content_box">
      <div class="agreement_content"
           v-html="content">
      </div>
    </div>
  </div>
</template>

<script>
import { agreement_section, agreement_section_id } from '@/api/hw'
export default {
  data() {
    return {
      content: '',
      configData: '',
      agreement_id: 148,
      screenWidth: '',
      imgSrc: require('@/assets/images/top_bg1.png'),
      logoSrc: require('@/assets/images/fundoll.png'),
    }
  },
  watch: {
    // 监听路由是否变化
    $route(to, from) {
      if (to.query.agreement_id != this.agreement_id) {
        this.init() // 重新调用加载数据方法
      }
    },
  },
  mounted() {
    window.onresize = () =>
      (() => {
        this.initScreen()
      })()
  },
  created() {
    this.initScreen()
    this.init()
  },
  methods: {
    initScreen() {
      const screenWidth = document.body.clientWidth
      console.log(this.screenWidth)
      if (screenWidth < 750) {
        // 屏幕宽度小于750
        // this.imgSrc = require('@/assets/images/top_bg1.1.png')
      } else if (parseInt(screenWidth) > 750 && screenWidth < 1334) {
        // 其余尺寸
        this.imgSrc = require('@/assets/images/top_bg2.1.png')
      } else {
        this.imgSrc = require('@/assets/images/top_bg3.1.png')
      }
    },
    init() {
      let configData = ''
      const processENV = process.env.NODE_ENV
      if (
        processENV.indexOf('development') > -1 ||
        processENV.indexOf('staging') > -1
      ) {
        configData = {
          platform: 'web',
          app_id: '904e9b2b0396ba6bdc2a8bb55b58398c',
          lang: 'zh-cn',
        }
      } else {
        configData = {
          platform: 'web',
          app_id: 'c96526e0fae0b978453ce0274c87a16d',
          lang: 'zh-cn',
        }
      }
      const logoName = this.$route.query.logo
        ? this.$route.query.logo.toLowerCase()
        : 'fundoll'
      this.logoSrc = require(`@/assets/images/${logoName}.png`)
      if (this.$route.query.section != 0) {
        const data = {
          agreement_id: this.$route.query.agreement_id,
          section: this.$route.query.section,
        }
        const msg = Object.assign(JSON.parse(JSON.stringify(configData)), data)
        agreement_section(msg).then((res) => {
          this.content = this.placechange(res.data.content)
        })
      } else {
        const data = {
          section_id: this.$route.query.section_id,
        }
        const msg = Object.assign(JSON.parse(JSON.stringify(configData)), data)
        agreement_section_id(msg).then((res) => {
          this.content = this.placechange(res.data.content)
        })
      }
    },
    placechange(data) {
      const content = data
        .replace(/<e>/g, '<div  style="width:100%;text-align:center;">')
        .replace(/<\/e>/g, '</div>')
        .replace(/<dt>/g, '<a style="color:blue;">')
        .replace(/<\/dt>/g, '</a>')
        .replace(/<red>/g, '<span style="color:red;">')
        .replace(/<\/red>/g, '</span>')
        .replace(/<b>/g, '<stong style=" font-weight: 700;color:#575757;">')
        .replace(/<\/b>/g, '</stong>')
        .replace(/\n/g, '</br>')
      return content
    },
    eventTemp(e) {
      //在判断事件目标节点的时候，考虑到兼容性应该统一转换成大写或小写进行判断
      if (e.target.localName.toLowerCase() === 'a') {
        // 通过判端目标节点以后，就能在这里对其进行操作啦。
        let id = e.target.getAttribute('data-href')
        console.log(e.target.getAttribute('data-href'))
        const msg = { code: 11, data: id }
        window.location = id
        appPostMessage(msg)
      }
    },
  },
}
</script>

<style lang="less" scope>
@media screen and(max-width:749px) {
  .agreement {
    height: 90vh;
    overflow: auto;
    padding-top: 130/75rem;
    padding-bottom: 30/75rem;
    white-space: normal;
    word-break: break-all;
    .tabBar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 80/75rem;
      background: url('../assets/images/top_bg1.1.png') no-repeat;
      background-size: cover;
      img {
        width: 280/75rem;
        height: auto;
        margin-left: 10px;
      }
    }
    .content_box {
      padding: 30/75rem;
      width: 90%;
      overflow: auto;
      height: 600px;
      background: #fff;
      box-shadow: 0px 17/75rem 26/75rem 1px rgba(0, 0, 0, 0.07);
      box-sizing: border-box;
      margin: 0 auto;
      border-radius: 6/75rem;
      margin-top: 30px;
    }
    .agreement_content {
      font-size: 24/75rem;
      color: #353535;
      margin-bottom: 80px;
      a {
        color: blue;
        font-size: 20/75rem;
      }
    }
  }
}
@media (min-width: 750px) and(max-width:1334px) {
  .agreement {
    margin-bottom: 30px;
    .content_box {
      padding: 30/75rem;
      // margin-top: 50px;
      // width: 690/75rem;
      width: 90%;
      height: 70vh;
      min-height: 500px;
      overflow: auto;
      background: #fff;
      box-shadow: 0px 17/75rem 26/75rem 1px rgba(0, 0, 0, 0.07);
      box-sizing: border-box;
      margin: 0 auto;
      border-radius: 6/75rem;
      margin-top: 100px;
    }
    .tabBar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background: url('../assets/images/top_bg2.1.png') no-repeat;
      background-size: cover;
      img {
        width: 270px;
        height: auto;
        margin-left: 10px;
      }
    }
    .agreement_content {
      font-size: 24/75rem;
      color: #353535;
      a {
        color: blue;
        font-size: 20/75rem;
      }
    }
  }
}
@media (min-width: 1335px) {
  .agreement {
    overflow: hidden;
    // .tabBar {
    //   min-width: 1920px;
    // }
    .tabBar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background: url('../assets/images/top_bg3.1.png') no-repeat;
      background-size: cover;
      img {
        width: 270px;
        height: auto;
        margin-left: 10px;
        position: absolute;
        left: 50%;
        transform: translateX(-180%);
      }
    }
    .content_box {
      padding: 30px;
      width: 986px;
      height: 88vh;
      overflow: auto;
      background: #fff;
      box-shadow: 0px 17px 26px1px rgba(0, 0, 0, 0.07);
      box-sizing: border-box;
      margin: 0 auto;
      border-radius: 6px;
      margin-top: 100px;
    }
    .agreement_content {
      font-size: 24/75rem;
      color: #353535;
      a {
        color: blue;
        font-size: 20/75rem;
      }
    }
  }
}
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #ccc;
    border-collapse: collapse;
    height: 30/75rem;
    line-height: 30/75rem;
    width: 20%;
  }
}
</style>